import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const HeroContainer = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  img {
    max-width: 400px;
    height: auto;
  }
`;

const HeroTitle = ({ input }) => {
  const { alt, dimensions, url } = input.primary.logo;

  return (
    <HeroContainer style={{ backgroundColor: input.primary.color }}>
      <img
        src={url}
        width={dimensions.width}
        height={dimensions.height}
        alt={alt}
      />
    </HeroContainer>
  );
};

HeroTitle.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroTitle;
